import { createContext } from 'react';

export const SingleViewContext = createContext<SingleViewContextProps>({
	index: 0,
	pages: [],
	setSwiper: () => {},
	setIndex: () => {},
	onNextArticleClick: () => {},
	onPrevArticleClick: () => {},
	toggleMenu: () => {},
});

interface SingleViewContextProps {
	swiper?: any;
	setSwiper: Function;
	index: number;
	setIndex: Function;
	pages: Array<any>;
	onNextArticleClick: Function;
	onPrevArticleClick: Function;
	toggleMenu: () => void;
}
